'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ClientData = require('conversations-schema/records/ClientData');

var _ClientData2 = _interopRequireDefault(_ClientData);

var _ChatConfig = require('conversations-schema/records/ChatConfig');

var _ChatConfig2 = _interopRequireDefault(_ChatConfig);

var _PubNubStatusCategories = require('conversations-core/constants/PubNubStatusCategories');

var PubNubStatusCategories = _interopRequireWildcard(_PubNubStatusCategories);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionTypeToKey = function actionTypeToKey(type) {
  return type.toLowerCase().replace(/_\w/g, function (word) {
    return word[1].toUpperCase();
  });
};

var initialState = (0, _ClientData2.default)();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.FORCE_CLIENT_OFFLINE, function (state) {
  return state.merge({
    isPubNubClientConnected: false,
    forceClientOffline: true
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CHAT_CONFIG_SUCCEEDED, function (state, action) {
  return state.set('chatConfig', (0, _ChatConfig2.default)(action.payload));
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBNUB_CLIENT_CONNECTED, function (state, action) {
  var newData = (0, _immutable.Map)({
    isPubNubClientConnected: true,
    uuid: action.payload
  });
  return state.merge(newData);
}), _defineProperty(_handleActions, _ActionTypes2.default.APP_IN_FOREGROUND, function (state) {
  return state.set('isInForeground', true);
}), _defineProperty(_handleActions, _ActionTypes2.default.APP_IN_BACKGROUND, function (state) {
  return state.set('isInForeground', false);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SERVER_TIME_OFFSET_SUCCEEDED, function (state, action) {
  return state.set('serverTimeOffsetInMs', action.payload.offsetInMs);
}), _defineProperty(_handleActions, _ActionTypes2.default.ADD_MESSAGE_TO_CONVERSATION, function (state, action) {
  var message = (0, _getIn2.default)(['payload', 'message'], action);

  if (!(0, _ConversationalMessageModel.isFromVisitor)(message)) return state;

  return state.update('sessionStartedAt', function (sessionStartedAt) {
    return sessionStartedAt || (0, _PubNubMessageModel.getClientTs)(message);
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.CONVERSATIONS_CLIENT_READY, function (state) {
  return state.update('sessionStartedAt', function (sessionStartedAt) {
    return sessionStartedAt || Date.now();
  });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_ActionTypes2.default.CONVERSATIONS_CLIENT_READY, _ActionTypes2.default.PUBNUB_CLIENT_CONNECTED, _ActionTypes2.default.SUBSCRIBE_CONFIRMATION, _ActionTypes2.default.GET_SERVER_TIME_OFFSET_SUCCEEDED), function (state, action) {
  var key = actionTypeToKey(action.type);
  return state.updateIn(['timestamps', key], function (timestamp) {
    return timestamp || Date.now();
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.RECEIVED_PUBNUB_STATUS, function (state, action) {
  if (action.payload.category === PubNubStatusCategories.NETWORK_DOWN) {
    return state.set('isPubNubClientConnected', false);
  } else if (action.payload.category === PubNubStatusCategories.NETWORK_UP) {
    return state.set('isPubNubClientConnected', true);
  }
  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/clientData.js
// module id = 506
// module chunks = 0